import { Box, Grid } from '@mui/material';
import theme from 'theme';
import OutOfOfficesTable from './OutOfOfficeRequestsTable';

const OutOfOfficesView = () => (
  <Box sx={{ padding: theme.spacing(4) }}>
    <Grid container spacing={4}>
      <Grid
        size={{
          lg: 12,
          md: 12,
          xl: 12,
          xs: 12,
        }}
      >
        <OutOfOfficesTable />
      </Grid>
    </Grid>
  </Box>
);

export default OutOfOfficesView;
